import { NavLink, Outlet } from 'react-router-dom';

const navLinkClassName = ({ isActive }: { isActive: boolean }) =>
    `rounded-md px-3 py-2 text-sm font-medium transition ${
        isActive
            ? 'bg-primary text-white'
            : 'text-gray-600 hover:bg-green-50 hover:text-primary'
    }`;

const AdminLayout = () => (
    <>
        <nav
            aria-label="Navigation de l’administration"
            className="mx-2 mt-6 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-sm lg:mx-auto lg:max-w-6xl"
        >
            <div className="flex flex-wrap items-center justify-between gap-3">
                <span className="font-semibold text-gray-900">Administration</span>
                <div className="flex flex-wrap items-center gap-1">
                    <NavLink end to="/admin" className={navLinkClassName}>Accueil</NavLink>
                    <NavLink to="/admin/gestion-des-contenus" className={navLinkClassName}>Contenus</NavLink>
                    <NavLink end to="/" className={navLinkClassName}>Voir le site</NavLink>
                </div>
            </div>
        </nav>
        <Outlet />
    </>
);

export default AdminLayout;
